import { render, staticRenderFns } from "./bezahltBtn.vue?vue&type=template&id=511e07a5&scoped=true&"
import script from "./bezahltBtn.vue?vue&type=script&lang=js&"
export * from "./bezahltBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511e07a5",
  null
  
)

export default component.exports